import Vue from "vue";
import axios from "axios";

axios.defaults.baseURL = process.env.VUE_APP_BASE_API_URL;
Vue.prototype.$http = axios;

export default {
    ItemLang:"lang00",
    Label : {
      Choix:"Choix",
      Statut:"Statut",
      ErreurSurvenue:"Une erreur est survenue",
      ListeProgrammes:"Liste des programmes choisis",
      ProgrammeSelectionne:"Programme retenu",
      StatutInscription : "Statut de votre candidature",
      DetailCandidature : "Détail de votre candidature",
      DateModification : "Date de modification",
      DerniereMiseAJour : "Dernière mise à jour",
      Details : "Détail"
    },
    LabelFr:{
      Choix:"Choix",
      Statut:"Statut",
      ErreurSurvenue:"Une erreur est survenue",
      ListeProgrammes:"Liste des programmes choisis",
      ProgrammeSelectionne:"Programme retenu",
      StatutInscription : "Statut de votre candidature",
      DetailCandidature : "Détail de votre candidature",
      DateModification : "Date de modification",
      DerniereMiseAJour : "Dernière mise à jour",
      Details : "Détail"
    },
    LabelEn:{
      Choix:"Choice",
      Statut:"Status",
      ErreurSurvenue:"An error has occurred",
      ListeProgrammes:"List of chosen programs",
      ProgrammeSelectionne:"Selected programme",
      StatutInscription : "Application status",
      DetailCandidature : "Application details",
      DateModification : "Updated at",
      DerniereMiseAJour : "Last updated at",
      Details : "Detail"
    },
    Data:{
        ListeInscriptions:[],
        DataId:{
          ProgrammeEnCours : 4945,
          ProgrammeAdmissible : 4944,
          ProgrammeNonAdmis : 4840,
        }
    },
    GetInformations(token){
    return axios
      .create({
        baseURL: process.env.VUE_APP_BASE_API_URL,
        withCredentials: false,
        headers: {
          Accept: "application/json",
          token: token,
        },
      })
      .get("sousmenu/GetInformations");
    },
    AffecterDto(dto){
        this.Data.ListeInscriptions = dto;
    },
}